import React, { Component } from 'react';
import { graphql, withApollo } from 'react-apollo';
import { compose, mapProps } from 'recompose';
import PropTypes from 'prop-types';

import ThreeppRadioGroup from 'components/common/RadioGroup/RadioGroup';
import { updateTemplateValuesListFieldValue } from 'graphql/operations';
import SaveTemplateAnswerHOC from '../SaveTemplateAnswerHOC';
import TemplateFieldUpdatesHOC from '../TemplateFieldUpdatesHOC';

export class TemplateOptionAnswer extends Component {
  static propTypes = {
    save: PropTypes.func.isRequired,
    // TODO: Fix this...
    // eslint-disable-next-line react/forbid-prop-types
    question: PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      value: props.question.listValue ? props.question.listValue[0] : null
    };
  }

  componentDidUpdate(prevProps) {
    const { question } = this.props;
    if (prevProps.question.listValue !== question.listValue) {
      // TODO: Figure this next issue out as it's a big code smell...
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({
        value: question.listValue ? question.listValue[0] : null
      });
    }
  }

  handleChange = value => {
    const { save } = this.props;
    this.setState({ value });
    save([value]);
  };

  render() {
    const { question, disabled } = this.props;
    const { value } = this.state;
    const { calculated } = question;
    const options = question.possibleValues.map(possibleValue => ({ value: possibleValue.value, label: possibleValue.value }));
    return <ThreeppRadioGroup options={options} disabled={calculated || disabled} selected={value} onChange={this.handleChange} />;
  }
}

export const TemplateOptionAnswerHOC = compose(
  withApollo,
  graphql(updateTemplateValuesListFieldValue, { name: 'fieldMutation' }),
  TemplateFieldUpdatesHOC,
  SaveTemplateAnswerHOC,
  mapProps(props => ({
    question: props.question,
    disabled: props.disabled,
    templateId: props.assessmentId,
    recordId: props.recordId,
    save: props.save
  }))
);

export default TemplateOptionAnswerHOC(TemplateOptionAnswer);
